import Axios from "axios";
import { getHrmEmployeeList, prefix } from "@/store/api";

const root = `${prefix}employee-benefit-funds`;

const get = (path, params = {}) => Axios.get(`${root}/${path}`, { params });
const post = (path, data = {}) => Axios.post(`${root}/${path}`, data);
const put = (path, data = {}) => Axios.put(`${root}/${path}`, data);
const remove = (path) => Axios.delete(`${root}/${path}`);

export const employeeBenefitFundsApi = {
  dashboard: () => get("dashboard"),

  settings: () => get("settings"),
  updateSettings: (payload) => put("settings", payload),

  accounts: (params) => get("accounts", params),
  createAccount: (payload) => post("accounts", payload),
  account: (id) => get(`accounts/${id}`),
  updateAccount: (id, payload) => put(`accounts/${id}`, payload),
  accountLedger: (id, params) => get(`accounts/${id}/ledger`, params),

  vouchers: (params) => get("vouchers", params),
  createVoucher: (payload) => post("vouchers", payload),
  voucher: (id) => get(`vouchers/${id}`),

  payrollTransfers: (params) => get("payroll-transfers", params),
  payrollTransfer: (id) => get(`payroll-transfers/${id}`),
  syncPayrollTransfer: (salaryProcessId) => post(`payroll-transfers/sync/${salaryProcessId}`),
  receivePayrollTransfer: (id, payload) => post(`payroll-transfers/${id}/receive`, payload),

  gratuityDeposits: (params) => get("gratuity-deposits", params),
  gratuityDeposit: (id) => get(`gratuity-deposits/${id}`),
  createGratuityDeposit: (payload) => post("gratuity-deposits", payload),

  claims: (params) => get("claims", params),
  claim: (id) => get(`claims/${id}`),
  createClaim: (payload) => post("claims", payload),
  approveClaim: (id, payload) => post(`claims/${id}/approve`, payload),
  rejectClaim: (id, payload) => post(`claims/${id}/reject`, payload),
  payClaim: (id, payload) => post(`claims/${id}/pay`, payload),
  removeClaimDocument: (claimId, documentId) => remove(`claims/${claimId}/documents/${documentId}`),

  report: (reportPath, params) => get(`reports/${reportPath}`, params),
  employeeStatement: (employeeId, params) => get(`reports/employee-statement/${employeeId}`, params),

  employees: (params = {}) => Axios.get(getHrmEmployeeList, { params }),
};

export default employeeBenefitFundsApi;
